export default {
  init() {
    $(document).ready(function(){
      let priceParas = $('p.price');
      if(priceParas.length > 1) {
        priceParas.not(':eq(0)').remove();
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js